import { useCallback, useState } from 'react';
import { Option } from 'models/Global';

export default function useSearchableFilters(
  getOptionsOnSearch: (searchString: string) => Promise<Option[]>,
) {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState<Option[]>([]);

  const resetState = useCallback(() => {
    setIsLoading(false);
    setOptions([]);
  }, []);

  const onSearch = useCallback(
    async (searchString: string) => {
      if (!searchString) {
        resetState();
        return;
      }

      setIsLoading(true);

      try {
        const options = await getOptionsOnSearch(searchString);

        setOptions(options);
      } catch {
        setOptions([]);
      } finally {
        setIsLoading(false);
      }
    },
    [getOptionsOnSearch, resetState],
  );

  return { isLoading, options, onSearch, resetState };
}
